import styled from '@emotion/styled';
import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import { withConfig } from 'src/withConfig';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';

export const MainWrapper = withConfig(theme => styled('div', { label: 'MainWrapper' })`
    height: 44px;
    width: 100%;
    padding: 8px;
    gap: 12px;
    display: inline-flex;
    background-color: ${theme.star.downloadAppBanner.bgColor};
`);

export const TextWrapper = styled('div', { label: 'TextWrapper' })`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Title = withConfig(theme => styled('div', { label: 'Title' })`
    color: ${theme.star.downloadAppBanner.txtColor};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.33;
`);

export const Subtitle = withConfig(theme => styled('div', { label: 'Subtitle' })`
    color: ${theme.star.downloadAppBanner.txtColorSecondary};
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
`);

export const DownloadButton = withConfig(theme => styled(Button, { label: 'DownloadButton' })`
    background-color: ${theme.star.downloadAppBanner.bgColorSecondary};
    color: ${theme.star.downloadAppBanner.txtColorTertiary};
    margin-left: auto;
    min-width: 52px;
    height: 24px;
`);

export const CloseButton = withConfig(theme => styled(CloseIcon, { label: 'CloseButton' })`
    width: 16px;
    height: 16px;
    fill: ${theme.star.downloadAppBanner.bgColorTertiary};
`);
